import watch   from "redux-watch";
import isEqual from 'is-equal';
import ControllerBase   from './controller_base';
import { api } from 'apps/api';
import {
  COMMENT_CLICK_REMOVE,
} from 'apps/events';
export default class ConnectController extends ControllerBase{
  constructor(tag) {
    super(tag);
    this.customEvent(COMMENT_CLICK_REMOVE, (e) => { this.onClickRemove(e) });
  }
  onClickRemove(e){
    let payload = {
      url: '/comments/' + e.detail,
      at: App.authenticity_token()
    }
    api.destroy(payload)
      .then((data) => {this.onDestroyed(data)})
      .catch((error) => {console.log(error);});
  }
  onDestroyed(data){
    this.dispatchNewValue(data.data.data)
  }
}
